import { Injectable } from '@angular/core';
import { RestService, Rest, PagedResultDto } from '@abp/ng.core';
import { IdentityUserService, GetIdentityUsersInput, IdentityUserDto } from '@volo/abp.ng.identity/proxy';
import { Observable } from 'rxjs';

/**
 * Extended IdentityUserService that overrides getList to include PaypalPayerId
 * from the Ac_Users table via our custom API endpoint.
 *
 * This service extends the standard ABP IdentityUserService and only overrides
 * the getList method to call our extended endpoint. All other methods delegate
 * to the original service.
 *
 * The response includes paypalPayerId and paypalEmailAddress from Ac_Users table,
 * which are additional to the standard IdentityUserDto properties.
 */
@Injectable({ providedIn: 'root' })
export class ExtendedIdentityUserServiceOverride extends IdentityUserService {

  private get rest(): RestService {
    return (this as any).restService;
  }

  /**
   * Override getList to call our extended API that includes PaypalPayerId.
   * The response is cast to the base type for compatibility, but the actual
   * response objects will contain the additional paypalPayerId property.
   */
  override getList = (input: GetIdentityUsersInput, config?: Partial<Rest.Config>): Observable<PagedResultDto<IdentityUserDto>> =>
    this.rest.request<any, PagedResultDto<IdentityUserDto>>({
      method: 'GET',
      url: `/api/app/extended-identity-user`,
      params: {
        filter: input.filter,
        roleId: input.roleId,
        organizationUnitId: input.organizationUnitId,
        userName: input.userName,
        phoneNumber: input.phoneNumber,
        emailAddress: input.emailAddress,
        name: input.name,
        surname: input.surname,
        isLockedOut: input.isLockedOut,
        notActive: input.notActive,
        emailConfirmed: input.emailConfirmed,
        isExternal: input.isExternal,
        maxCreationTime: input.maxCreationTime,
        minCreationTime: input.minCreationTime,
        maxModifitionTime: input.maxModifitionTime,
        minModifitionTime: input.minModifitionTime,
        sorting: input.sorting,
        skipCount: input.skipCount,
        maxResultCount: input.maxResultCount,
      },
    }, config ?? { apiName: this.apiName });
}
